export default {
  acceptedshipment: {
    title: "Звіт про прийняте відвантаження",
    period: "Період",
    periodNotSelected: "Поле період не може бути порожнім"
  }
};
